var Ee = Object.defineProperty, De = Object.defineProperties;
var Me = Object.getOwnPropertyDescriptors;
var me = Object.getOwnPropertySymbols;
var je = Object.prototype.hasOwnProperty, Ve = Object.prototype.propertyIsEnumerable;
var fe = (O, I, v) => I in O ? Ee(O, I, { enumerable: !0, configurable: !0, writable: !0, value: v }) : O[I] = v, S = (O, I) => {
  for (var v in I || (I = {}))
    je.call(I, v) && fe(O, v, I[v]);
  if (me)
    for (var v of me(I))
      Ve.call(I, v) && fe(O, v, I[v]);
  return O;
}, Z = (O, I) => De(O, Me(I));
var ge = (O, I, v) => new Promise((J, F) => {
  var H = (k) => {
    try {
      M(v.next(k));
    } catch (P) {
      F(P);
    }
  }, A = (k) => {
    try {
      M(v.throw(k));
    } catch (P) {
      F(P);
    }
  }, M = (k) => k.done ? J(k.value) : Promise.resolve(k.value).then(H, A);
  M((v = v.apply(O, I)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getshowerRoomModelOption as ve, reqConvertMscsContent as Se } from "../../../../request/template/post.js";
import { getOssUrl as Re } from "@oppein/op-utils";
import { defineComponent as ze, computed as Ge, watch as Fe, resolveDirective as Le, openBlock as d, createBlock as h, withCtx as i, withDirectives as $e, createElementBlock as G, createVNode as u, createElementVNode as D, Fragment as W, renderList as U, createCommentVNode as b, createTextVNode as R } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { withKeys as Ae, withModifiers as Pe } from "../../../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { useMessage as Be } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as _, reactive as re, unref as s } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import y from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import w from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import C from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import Te from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/auto-complete/src/AutoComplete.js";
import B from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import z from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import he from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import q from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import Ke from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import ce from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import Ze from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import { toDisplayString as E } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import be from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
const qe = { class: "shower-room-model" }, Je = {
  key: 0,
  class: "shower-room"
}, He = ["src"], Qe = { key: 0 }, Xe = { class: "bottom-box" }, Io = /* @__PURE__ */ ze({
  __name: "ShowerRoomModel",
  props: {
    orderParam: {},
    showerRoomModelOptions: {},
    showerRoomModelParams: {},
    openType: {}
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(O, { emit: I }) {
    const v = O, J = I, F = Be(), H = _(!0), A = _(!1), M = _(!1), k = _(!1), P = _(!1), oe = _(!1), T = _(""), j = _(null), Q = _({}), X = _(null), x = _(""), Ne = _(""), L = re({
      name: ""
    }), Y = _([]), Ie = Ge(() => Y.value.filter(
      (n) => n.name.toLowerCase().includes(L.name.toLowerCase())
    )), e = re({
      productGroup: { groupId: "", groupName: "", gategories: [] }
    }), se = re({
      judge: [
        { code: !0, name: "是" },
        { code: !1, name: "否" }
      ]
    }), c = Ge(() => v.openType === "view"), ke = () => {
      var n;
      Ne.value = ((n = v.orderParam) == null ? void 0 : n.productionId) || "", ve({
        searchKeyWord: "",
        type: 0
      }).then((t) => {
        Y.value = [], t.data.length && t.data.forEach((m) => {
          Y.value.push(S({ value: m.name }, m));
        });
      }).catch((t) => {
        console.log("获取产品编码下拉值error", t);
      });
    }, ne = () => {
      x.value = L.name, x.value && de(x.value);
    }, ye = (n) => {
    }, we = (n) => {
      L.name = n.name;
    }, le = (n = "") => {
      var m;
      P.value = !1;
      let t = "";
      if (e.glassGroup && e.filmGroup) {
        const o = (m = e.filmGroup.gategories.find(
          (a) => {
            var l;
            return a.name === ((l = e.filmGroup) == null ? void 0 : l.modelName);
          }
        )) == null ? void 0 : m.options;
        if (o) {
          const a = o.find(
            (l) => {
              var r, p;
              return l.optionId === ((p = (r = e.filmGroup) == null ? void 0 : r.gategories.find((f) => {
                var g;
                return f.name === ((g = e.filmGroup) == null ? void 0 : g.modelName);
              })) == null ? void 0 : p.model);
            }
          );
          a && (t = a.name);
        }
        P.value = e.glassGroup.modelName === "无特殊工艺" || t === "TM00无贴膜";
      }
      P.value || (M.value = !1), e.nanometerGroup && n && (M.value = e.nanometerGroup.otherValue === !0);
    }, ie = (n = "") => {
      var t;
      oe.value = !1, ((t = e.stoneGroup) == null ? void 0 : t.modelName) !== "不配" && (oe.value = !0), oe.value || (k.value = !1), e.stoneGroupFirst && n && (k.value = e.stoneGroupFirst.otherValue === "true");
    }, ae = (n) => {
      var t, m, o, a;
      if (n === "thicknessGroup") {
        const l = (t = e[n]) == null ? void 0 : t.gategories[0];
        if (l) {
          const r = l.options.find((p) => p.optionId === l.model);
          (m = r == null ? void 0 : r.relations) != null && m.length && (r.modelId = r.relations[0].optionId || "");
        }
      } else {
        const l = (o = e[n]) == null ? void 0 : o.gategories.find((r) => {
          var p;
          return r.name === ((p = e[n]) == null ? void 0 : p.modelName);
        });
        (a = l == null ? void 0 : l.options) != null && a.length && (l.model = l.options[0].optionId || "");
      }
    }, N = (n) => {
      var t, m, o, a;
      n === "玻璃工艺" && ((t = e.glassGroup) == null || t.gategories.forEach((l) => {
        l.model = "";
      }), ae("glassGroup"), le()), n === "玻璃贴膜" && le(), n === "拉手款式" && ((m = e.handleGroup) == null || m.gategories.forEach((l) => {
        l.model = "";
      }), ae("handleGroup")), n === "石基" && ((o = e.stoneGroup) == null || o.gategories.forEach((l) => {
        l.model = "";
      }), ie()), n === "产品颜色" && e.handleGroup && (e.handleGroup.modelName = "", e.handleGroup.gategories.forEach((l) => {
        l.model = "";
      })), n === "玻璃厚度" && ((a = e.thicknessGroup) == null || a.gategories.forEach((l) => {
        l.options.forEach((r) => {
          r.modelId = "";
        });
      }), ae("thicknessGroup"));
    }, ue = () => {
      for (const n in e) {
        let t = "";
        const m = e[n];
        m && m.gategories && (n === "thicknessGroup" && (m.gategories = m.gategories.filter((o) => o.name === "活动玻璃厚度")), m.gategories.forEach((o, a) => {
          let l = "";
          o.options.length && o.options.forEach((r, p) => {
            if (o.options[p].isDefault = !1, r.isDefault || r.doorWidth) {
              if (r.isDefault && (l = r.optionId), t = o.name, r.relations && r.relations.length) {
                let f = "";
                r.relations.forEach((g, $) => {
                  g.isDefault && (f = g.optionId);
                }), o.options[p] = Z(S({}, r), { modelId: f || "" });
              }
              r.doorWidth && (o.options[p] = Z(S({}, r), {
                doorWidthNumber: te(r.doorWidth) || ""
              }));
            }
            r.properties && r.properties.length && r.properties.forEach((f) => {
              f.defaults = Number(f.defaults), f.formula && (j.value = S({}, f));
            });
          }), m.gategories[a] = Z(S({}, o), { model: l });
        })), t && (e[n] = Z(S({}, m), { modelName: t || null }));
      }
      if (Y.value.length) {
        const n = Y.value.find((t) => t.name === x.value);
        n && (e.series = n.series);
      }
      e.otherGroup && (T.value = e.otherGroup.otherValue || ""), le("init"), ie("init"), X.value && We(e, X.value);
    }, de = (n, t) => {
      A.value = !0, j.value = null;
      const m = {
        modelName: n,
        channel: v.orderParam.checkProductChannel
      };
      t && !v.orderParam.checkProductChannel && (m.isNeedChannel = !1), ve(m).then((o) => {
        A.value = !1, Object.keys(e).forEach((l) => {
          delete e[l];
        }), e.productGroup = { groupId: "", groupName: "", gategories: [] };
        const a = o.data;
        for (const l in a)
          l !== "productGroupOld" && a[l] && JSON.stringify(a[l]) !== "[]" && (e[l] = a[l]);
        ue(), Q.value = S({}, e), ee();
      }).catch((o) => {
        e.productGroup = { groupId: "", groupName: "", gategories: [] }, A.value = !1, console.log("获取报文接口error", o);
      });
    }, te = (n = "") => {
      if (!n)
        return "";
      let t = n.toLowerCase();
      t.indexOf("l") > -1 && (t = t.replace(/l/g, V("l"))), t.indexOf("w") > -1 && (t = t.replace(/w/g, V("w"))), t.indexOf("h") > -1 && t.indexOf("h1") === -1 && (t = t.replace(/h/g, V("h"))), t.indexOf("g1") > -1 && (t = t.replace(/g1/g, V("g1"))), t.indexOf("g2") > -1 && (t = t.replace(/g2/g, V("g2"))), t.indexOf("h1") > -1 && (t = t.replace(/h1/g, V("h1")));
      try {
        const m = Function;
        return new m("return " + t)();
      } catch (m) {
        return 0;
      }
    }, V = (n = "l", t = e) => {
      var o, a;
      if (["l", "w", "h"].includes(n)) {
        const l = t.productGroup;
        if (!l)
          return "0";
        const r = l.gategories.find((g) => g.name === l.modelName);
        if (!r)
          return "0";
        const p = r.options.find((g) => g.optionId === r.model);
        if (!p)
          return "0";
        const f = (o = p.properties) == null ? void 0 : o.find((g) => g.code.toLowerCase() === n);
        return (f == null ? void 0 : f.defaults.toString()) || "0";
      } else if (n.indexOf("g") > -1 || n.indexOf("h") > -1) {
        const l = t.glassWidthGroup;
        if (!l)
          return "0";
        const r = l.gategories[0].options.find(
          (f) => f.properties && f.properties.length
        );
        if (!r)
          return "0";
        const p = (a = r.properties) == null ? void 0 : a.find((f) => f.code.toLowerCase() === n);
        return (p == null ? void 0 : p.defaults.toString()) || "0";
      }
      return "0";
    }, Ce = (n = "", t, m = e) => {
      var a, l;
      const o = ["l", "w", "h"];
      if (n) {
        if (o.includes(n)) {
          const r = m.productGroup;
          if (!r)
            return;
          const p = r.gategories.find(($) => $.name === r.modelName);
          if (!p)
            return;
          const f = p.options.find(($) => $.optionId === p.model);
          if (!f)
            return;
          const g = (a = f.properties) == null ? void 0 : a.find(($) => $.code.toLowerCase() === n);
          g && (g.defaults = t, ee());
        } else if (n.indexOf("g") > -1 || n.indexOf("h") > -1) {
          const r = m.glassWidthGroup;
          if (!r)
            return;
          const p = r.gategories[0].options.find(
            (g) => g.properties && g.properties.length
          );
          if (!p)
            return;
          const f = (l = p.properties) == null ? void 0 : l.find((g) => g.code.toLowerCase() === n);
          f && (f.defaults = t, ee());
        }
      }
    }, K = (n) => {
      var o, a;
      if (!n.length || !e.doorGroup)
        return;
      const t = e.doorGroup.gategories.find((l) => {
        var r;
        return l.name === ((r = e.doorGroup) == null ? void 0 : r.modelName);
      });
      if (!t)
        return;
      const m = t.options.map((l) => l.name.replace(/[^a-zA-Z]/gi, "")).join();
      t.options = ((a = (o = Q.value.doorGroup) == null ? void 0 : o.gategories.find((l) => {
        var r;
        return l.name === ((r = e.doorGroup) == null ? void 0 : r.modelName);
      })) == null ? void 0 : a.options.filter((l) => n.includes(l.name.replace(/[^a-zA-Z]/gi, "")))) || [], t.options.length && n.join() !== m && (t.model = t.options[0].optionId);
    }, ee = (n) => {
      var m, o;
      if (!x.value)
        return;
      if (x.value[5] === "D") {
        const a = Number(V("l")), l = Number(V("w"));
        a === l ? K(["LA", "RA"]) : a > l ? K(["LL", "RL"]) : K(["LR", "RR"]);
      }
      if (x.value.slice(5, 8) === "F42") {
        const a = Number(V("l")), l = Number(V("w"));
        a === l ? K(["AA"]) : a > l ? K(["AL"]) : K(["AR"]);
      }
      const t = ((m = e.glassWidthGroup) == null ? void 0 : m.gategories.find(
        (a) => {
          var l;
          return a.name === ((l = e.glassWidthGroup) == null ? void 0 : l.modelName);
        }
      )) || ((o = e.glassWidthGroup) == null ? void 0 : o.gategories[0]);
      if (t) {
        const a = t.options.find(
          (l) => l.optionId === t.model
        );
        a != null && a.doorWidth && (a.doorWidthNumber = te(a.doorWidth) || "");
      }
      n && pe(n);
    }, pe = (n) => {
      let t = !0;
      if (!j.value || !e.glassWidthGroup)
        return t;
      const m = e.glassWidthGroup.gategories[0], o = m.options.find(
        (a) => a.optionId === m.model
      );
      if ((o == null ? void 0 : o.name) === "非标")
        try {
          const a = te(j.value.formula);
          if (a < j.value.min || a > j.value.max) {
            F.warning(
              `计算得到的${j.value.code}超出范围，计算公式：${j.value.formula}，上下限：${j.value.min}----${j.value.max}`,
              { duration: 5e3 }
            ), t = !1;
            const l = n.toLowerCase();
            Ce(l, Number(V(l, Q.value)));
          }
        } catch (a) {
          F.error("公式计算错误"), t = !1;
        }
      return t;
    }, We = (n, t) => {
      Object.keys(n).forEach((m) => {
        const o = n[m];
        typeof o == "object" && o !== null && t.Groups.forEach((a) => {
          o.groupId === a.GroupId && o.gategories.forEach((l) => {
            l.options.forEach((r) => {
              r.isDefault = !1, (r.optionId === a.Categories[0].Options[0].OptionId || !r.optionId && r.name === a.Categories[0].Options[0].Name) && (r.isDefault = !0, o.modelName = l.name, l.model = r.optionId), o.groupId === "1" && r.properties && r.properties.forEach((p) => {
                a.Categories[0].Options[0].Properties.forEach((f) => {
                  p.propertyId === f.PropertyId && (p.defaults = f.Default);
                });
              }), o.groupId === "5" && r.relations && r.relations.forEach((p) => {
                p.isDefault = !1, a.Categories[1] && a.Categories[1].Options[0].Name === p.relationData && (p.isDefault = !0);
              });
            });
          }), a.GroupName === "客户其它内容" && (T.value = a.OtherValue), (a.GroupName === "纳米易结" || a.GroupName === "纳米易洁") && (M.value = a.First || !1), a.GroupName === "石基先发" && (k.value = a.First || !1);
        });
      });
    }, Ue = () => {
      var n;
      if (v.showerRoomModelOptions.content) {
        const t = v.showerRoomModelOptions.content;
        X.value = "", t.Success ? (X.value = t.Content, x.value = X.value.Name, L.name = x.value, de(x.value, "isNeedChannel")) : (Object.keys(t).forEach((m) => {
          e[m] = t[m];
        }), Q.value = S({}, e), x.value = e.name, L.name = x.value, ue(), (n = v.showerRoomModelOptions.content) != null && n.stoneGroupFirst && (k.value = v.showerRoomModelOptions.content.stoneGroupFirst.otherValue));
      } else
        v.showerRoomModelOptions.productModel && (L.name = v.showerRoomModelOptions.productModel, ne());
    }, Oe = () => ge(this, null, function* () {
      var o, a;
      if (e.handleGroup && e.handleGroup.gategories.length && !e.handleGroup.modelName) {
        F.warning("请选择拉手款式！");
        return;
      }
      if (e.stoneGroup && e.stoneGroup.gategories.length && !((o = e.stoneGroup.gategories.find((l) => {
        var r;
        return l.name === ((r = e.stoneGroup) == null ? void 0 : r.modelName);
      })) != null && o.model)) {
        F.warning("请正确选择石基！");
        return;
      }
      if (e.thicknessGroup && e.thicknessGroup.gategories.length) {
        const l = e.thicknessGroup.gategories[0], r = l.options.find((p) => p.optionId === l.model);
        if (!(r != null && r.modelId)) {
          F.warning("请正确选择固定玻璃厚度！");
          return;
        }
      }
      if (e.doorGroup && e.doorGroup.gategories.length && !((a = e.doorGroup.gategories.find((l) => {
        var r;
        return l.name === ((r = e.doorGroup) == null ? void 0 : r.modelName);
      })) != null && a.model)) {
        F.warning("请选择开门方向与产品方向");
        return;
      }
      if (!pe(""))
        return;
      const n = S({}, e), t = [];
      for (const l in n) {
        const r = n[l];
        r && r.gategories && r.gategories.forEach((p) => {
          p.options.length && p.options.forEach((f) => {
            if (f.isDefault = !1, f.optionId === p.model && (f.isDefault = !0, r.groupId && f.optionId && t.push({
              groupId: r.groupId,
              optionId: f.optionId,
              nonStandard: l === "glassWidthGroup" && f.name === "非标",
              nonStandardValue: "",
              properties: l === "glassWidthGroup" && f.properties ? f.properties.filter((g) => g.code !== "G2").map((g) => ({
                nonStandardValue: g.defaults + "",
                propertyId: g.propertyId
              })) : []
            }), f.relations && f.relations.length && f.relations.forEach((g) => {
              g.optionId === f.modelId && t.push({
                groupId: r.groupId,
                optionId: g.optionId,
                nonStandard: !1,
                nonStandardValue: "",
                properties: []
              });
            })), f.properties && f.properties.length && r.groupId === "1") {
              const g = f.properties.map(($) => ({
                nonStandardValue: $.defaults + "",
                propertyId: $.propertyId
              }));
              t.length > 0 && (t[t.length - 1].properties = g);
            }
          });
        });
      }
      n.nanometerGroup = {
        groupId: "",
        groupName: "纳米易洁",
        otherValue: M.value,
        gategories: []
      }, n.stoneGroupFirst = {
        groupId: "",
        groupName: "石基先发",
        otherValue: k.value,
        gategories: []
      }, n.otherGroup = {
        groupId: "",
        groupName: "客户其它内容",
        otherValue: T.value,
        gategories: []
      };
      const m = {
        modelId: e.modelId,
        nmyj: M.value,
        options: t,
        remark: T.value,
        sjxf: k.value,
        content: n
      };
      A.value = !0;
      try {
        const l = yield Se(Z(S({}, m), { type: 0 }));
        m.mscsContent = l, J("onSuccess", m);
      } catch (l) {
        F.error("提交失败，请重试");
      } finally {
        A.value = !1;
      }
    }), xe = () => {
      J("hide-dialog");
    }, _e = () => {
      J("hide-dialog");
    };
    return Fe(
      () => H.value,
      (n) => {
        n && (Object.keys(e).forEach((t) => {
          delete e[t];
        }), e.productGroup = { groupId: "", groupName: "", gategories: [] }, Q.value = {}, j.value = null, L.name = "", x.value = "", ke(), Ue());
      },
      { immediate: !0 }
    ), (n, t) => {
      const m = Le("loading");
      return d(), h(s(Ze), {
        show: H.value,
        "onUpdate:show": t[24] || (t[24] = (o) => H.value = o),
        title: "淋浴房",
        width: 1200,
        "mask-closable": !1,
        centered: "",
        onClose: _e
      }, {
        default: i(() => [
          $e((d(), G("div", qe, [
            u(s(Ke), {
              inline: "",
              onSubmit: t[23] || (t[23] = Pe(() => {
              }, ["prevent"]))
            }, {
              default: i(() => [
                u(s(y), { class: "bottom-line" }, {
                  default: i(() => [
                    u(s(w), { span: 16 }, {
                      default: i(() => [
                        u(s(C), {
                          label: "淋浴房型号:",
                          "label-placement": "left"
                        }, {
                          default: i(() => [
                            u(s(Te), {
                              value: L.name,
                              "onUpdate:value": t[0] || (t[0] = (o) => L.name = o),
                              disabled: !0,
                              options: Ie.value,
                              placeholder: "请输入淋浴房型号",
                              onInput: ye,
                              onSelect: we,
                              onKeyup: Ae(ne, ["enter"])
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                D("div", null, [
                  e.productGroup && e.productGroup.gategories.length ? (d(), h(s(y), {
                    key: 0,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.productGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              (d(!0), G(W, null, U(e.productGroup.gategories, (o, a) => (d(), G("div", { key: a }, [
                                u(s(q), {
                                  disabled: c.value,
                                  value: o.model,
                                  "onUpdate:value": [(l) => o.model = l, N]
                                }, {
                                  default: i(() => [
                                    (d(!0), G(W, null, U(o.options, (l, r) => (d(), h(s(B), {
                                      key: r,
                                      value: l.optionId
                                    }, {
                                      default: i(() => [
                                        R(E(l.name === "标准" ? "常规" : l.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "value", "onUpdate:value"]),
                                (d(!0), G(W, null, U(o.options, (l, r) => (d(), G("div", { key: r }, [
                                  l.optionId === o.model ? (d(!0), G(W, { key: 0 }, U(l.properties, (p, f) => (d(), G("div", {
                                    key: f,
                                    class: "chang-gui-cell"
                                  }, [
                                    D("span", null, E(p.name + "："), 1),
                                    u(s(be), {
                                      disabled: c.value,
                                      value: p.defaults,
                                      "onUpdate:value": [(g) => p.defaults = g, () => ee(p.code)],
                                      clearable: "",
                                      max: p.max * 1,
                                      min: p.min * 1
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "max", "min"]),
                                    D("span", null, "常规：" + E(p.min) + "-" + E(p.max) + " mm", 1)
                                  ]))), 128)) : b("", !0)
                                ]))), 128))
                              ]))), 128))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.doorGroup && e.doorGroup.gategories.length ? (d(), h(s(y), {
                    key: 1,
                    class: "kaimenfangxing"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.doorGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              (d(!0), G(W, null, U(e.doorGroup.gategories, (o, a) => (d(), G("div", { key: a }, [
                                D("span", null, E(o.name) + "：", 1),
                                u(s(z), {
                                  value: o.model,
                                  "onUpdate:value": [(l) => o.model = l, N],
                                  size: "small",
                                  placeholder: "请选择",
                                  disabled: c.value,
                                  options: o.options,
                                  "label-field": "name",
                                  "value-field": "optionId"
                                }, null, 8, ["value", "onUpdate:value", "disabled", "options"])
                              ]))), 128))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      e.doorGroup.gategories.filter(
                        (o) => {
                          var a;
                          return o.name === ((a = e.doorGroup) == null ? void 0 : a.modelName);
                        }
                      )[0].options.length ? (d(), G("div", Je, [
                        D("img", {
                          src: s(Re)({ url: e.doorGroup.gategories.filter((o) => {
                            var a;
                            return o.name === ((a = e.doorGroup) == null ? void 0 : a.modelName);
                          })[0].options.filter(
                            (o) => {
                              var a;
                              return o.optionId === ((a = e.doorGroup) == null ? void 0 : a.gategories.filter(
                                (l) => {
                                  var r;
                                  return l.name === ((r = e.doorGroup) == null ? void 0 : r.modelName);
                                }
                              )[0].model);
                            }
                          )[0].sketchMap }),
                          alt: ""
                        }, null, 8, He)
                      ])) : b("", !0)
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.productColorGroup && e.productColorGroup.gategories.length ? (d(), h(s(y), {
                    key: 2,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.productColorGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              (d(!0), G(W, null, U(e.productColorGroup.gategories, (o, a) => (d(), G("div", { key: a }, [
                                u(s(q), {
                                  disabled: c.value,
                                  value: o.model,
                                  "onUpdate:value": [
                                    (l) => o.model = l,
                                    t[1] || (t[1] = () => N("产品颜色"))
                                  ]
                                }, {
                                  default: i(() => [
                                    (d(!0), G(W, null, U(o.options, (l, r) => (d(), h(s(B), {
                                      key: r,
                                      value: l.optionId
                                    }, {
                                      default: i(() => [
                                        R(E(l.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "value", "onUpdate:value"])
                              ]))), 128))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.glassGroup && e.glassGroup.gategories.length ? (d(), h(s(y), {
                    key: 3,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.glassGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(B), {
                                disabled: c.value,
                                value: e.glassGroup.modelName,
                                "onUpdate:value": t[2] || (t[2] = (o) => e.glassGroup.modelName = o),
                                style: { float: "left" }
                              }, {
                                default: i(() => t[25] || (t[25] = [
                                  R(" 标准 ", -1)
                                ])),
                                _: 1,
                                __: [25]
                              }, 8, ["disabled", "value"]),
                              u(s(z), {
                                value: e.glassGroup.modelName,
                                "onUpdate:value": [
                                  t[3] || (t[3] = (o) => e.glassGroup.modelName = o),
                                  t[4] || (t[4] = () => N("玻璃工艺"))
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.glassGroup.gategories,
                                "label-field": "name",
                                "value-field": "name"
                              }, null, 8, ["value", "disabled", "options"]),
                              u(s(z), {
                                value: e.glassGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.glassGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].model,
                                "onUpdate:value": [
                                  t[5] || (t[5] = (o) => e.glassGroup.gategories.filter(
                                    (a) => {
                                      var l;
                                      return a.name === ((l = e.glassGroup) == null ? void 0 : l.modelName);
                                    }
                                  )[0].model = o),
                                  N
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.glassGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.glassGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].options,
                                "label-field": "name",
                                "value-field": "optionId"
                              }, null, 8, ["value", "disabled", "options"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.filmGroup && e.filmGroup.gategories.length ? (d(), h(s(y), {
                    key: 4,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.filmGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(B), {
                                disabled: c.value,
                                value: e.filmGroup.modelName,
                                "onUpdate:value": t[6] || (t[6] = (o) => e.filmGroup.modelName = o),
                                style: { float: "left" }
                              }, {
                                default: i(() => t[26] || (t[26] = [
                                  R(" 标准 ", -1)
                                ])),
                                _: 1,
                                __: [26]
                              }, 8, ["disabled", "value"]),
                              u(s(z), {
                                value: e.filmGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.filmGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].model,
                                "onUpdate:value": [
                                  t[7] || (t[7] = (o) => e.filmGroup.gategories.filter(
                                    (a) => {
                                      var l;
                                      return a.name === ((l = e.filmGroup) == null ? void 0 : l.modelName);
                                    }
                                  )[0].model = o),
                                  t[8] || (t[8] = () => N("玻璃贴膜"))
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.filmGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.filmGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].options,
                                "label-field": "name",
                                "value-field": "optionId"
                              }, null, 8, ["value", "disabled", "options"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.thicknessGroup && e.thicknessGroup.gategories.length ? (d(), h(s(y), {
                    key: 5,
                    class: "bolihoudu"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.thicknessGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              D("div", null, [
                                t[27] || (t[27] = D("span", null, "活动玻璃厚度：", -1)),
                                u(s(z), {
                                  value: e.thicknessGroup.gategories.filter(
                                    (o) => {
                                      var a;
                                      return o.name === ((a = e.thicknessGroup) == null ? void 0 : a.modelName);
                                    }
                                  )[0].model,
                                  "onUpdate:value": [
                                    t[9] || (t[9] = (o) => e.thicknessGroup.gategories.filter(
                                      (a) => {
                                        var l;
                                        return a.name === ((l = e.thicknessGroup) == null ? void 0 : l.modelName);
                                      }
                                    )[0].model = o),
                                    t[10] || (t[10] = () => N("玻璃厚度"))
                                  ],
                                  size: "small",
                                  disabled: c.value,
                                  options: e.thicknessGroup.gategories.filter(
                                    (o) => {
                                      var a;
                                      return o.name === ((a = e.thicknessGroup) == null ? void 0 : a.modelName);
                                    }
                                  )[0].options,
                                  "label-field": "name",
                                  "value-field": "optionId"
                                }, null, 8, ["value", "disabled", "options"])
                              ]),
                              D("div", null, [
                                t[28] || (t[28] = D("span", null, "固定玻璃厚度：", -1)),
                                u(s(z), {
                                  value: e.thicknessGroup.gategories.filter((o) => {
                                    var a;
                                    return o.name === ((a = e.thicknessGroup) == null ? void 0 : a.modelName);
                                  })[0].options.filter(
                                    (o) => {
                                      var a;
                                      return o.optionId === ((a = e.thicknessGroup) == null ? void 0 : a.gategories.filter(
                                        (l) => {
                                          var r;
                                          return l.name === ((r = e.thicknessGroup) == null ? void 0 : r.modelName);
                                        }
                                      )[0].model);
                                    }
                                  )[0].modelId,
                                  "onUpdate:value": [
                                    t[11] || (t[11] = (o) => e.thicknessGroup.gategories.filter((a) => {
                                      var l;
                                      return a.name === ((l = e.thicknessGroup) == null ? void 0 : l.modelName);
                                    })[0].options.filter(
                                      (a) => {
                                        var l;
                                        return a.optionId === ((l = e.thicknessGroup) == null ? void 0 : l.gategories.filter(
                                          (r) => {
                                            var p;
                                            return r.name === ((p = e.thicknessGroup) == null ? void 0 : p.modelName);
                                          }
                                        )[0].model);
                                      }
                                    )[0].modelId = o),
                                    N
                                  ],
                                  size: "small",
                                  disabled: c.value,
                                  options: e.thicknessGroup.gategories.filter((o) => {
                                    var a;
                                    return o.name === ((a = e.thicknessGroup) == null ? void 0 : a.modelName);
                                  })[0].options.filter(
                                    (o) => {
                                      var a;
                                      return o.optionId === ((a = e.thicknessGroup) == null ? void 0 : a.gategories.filter(
                                        (l) => {
                                          var r;
                                          return l.name === ((r = e.thicknessGroup) == null ? void 0 : r.modelName);
                                        }
                                      )[0].model);
                                    }
                                  )[0].relations,
                                  "label-field": "relationData",
                                  "value-field": "optionId"
                                }, null, 8, ["value", "disabled", "options"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.glassWidthGroup && e.glassWidthGroup.gategories.length ? (d(), h(s(y), {
                    key: 6,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.glassWidthGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              (d(!0), G(W, null, U(e.glassWidthGroup.gategories, (o, a) => (d(), G("div", { key: a }, [
                                u(s(q), {
                                  disabled: c.value,
                                  value: o.model,
                                  "onUpdate:value": [(l) => o.model = l, N]
                                }, {
                                  default: i(() => [
                                    (d(!0), G(W, null, U(o.options, (l, r) => (d(), h(s(B), {
                                      key: r,
                                      value: l.optionId
                                    }, {
                                      default: i(() => [
                                        R(E(l.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "value", "onUpdate:value"]),
                                o.options.filter((l) => l.optionId === o.model)[0].properties ? (d(), G("div", Qe, [
                                  (d(!0), G(W, null, U(o.options.filter((l) => l.optionId === o.model)[0].properties, (l) => (d(), G("div", {
                                    key: l.propertyId
                                  }, [
                                    l.formula ? b("", !0) : (d(), G(W, { key: 0 }, [
                                      R(E(l.name) + " : ", 1),
                                      u(s(be), {
                                        disabled: c.value || !l.modifiable,
                                        value: l.defaults,
                                        "onUpdate:value": [(r) => l.defaults = r, () => ee(l.code)],
                                        clearable: "",
                                        max: l.max * 1,
                                        min: l.min * 1
                                      }, null, 8, ["disabled", "value", "onUpdate:value", "max", "min"]),
                                      D("span", null, E(l.min) + "-" + E(l.max) + " mm", 1)
                                    ], 64))
                                  ]))), 128))
                                ])) : b("", !0)
                              ]))), 128))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.glassWidthGroup && e.glassWidthGroup.gategories.length ? (d(), h(s(y), {
                    key: 7,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      e.glassWidthGroup.gategories[0].options.filter(
                        (o) => {
                          var a;
                          return o.optionId === ((a = e.glassWidthGroup) == null ? void 0 : a.gategories[0].model);
                        }
                      )[0].doorWidthNumber ? (d(), h(s(w), {
                        key: 0,
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: "进门宽度:",
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(he), {
                                disabled: "",
                                modelValue: e.glassWidthGroup.gategories[0].options.filter(
                                  (o) => {
                                    var a;
                                    return o.optionId === ((a = e.glassWidthGroup) == null ? void 0 : a.gategories[0].model);
                                  }
                                )[0].doorWidthNumber,
                                "onUpdate:modelValue": t[12] || (t[12] = (o) => e.glassWidthGroup.gategories[0].options.filter(
                                  (a) => {
                                    var l;
                                    return a.optionId === ((l = e.glassWidthGroup) == null ? void 0 : l.gategories[0].model);
                                  }
                                )[0].doorWidthNumber = o)
                              }, null, 8, ["modelValue"]),
                              t[29] || (t[29] = D("div", { style: { width: "40px" } }, "mm", -1))
                            ]),
                            _: 1,
                            __: [29]
                          })
                        ]),
                        _: 1
                      })) : b("", !0)
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.productGroup ? (d(), h(s(y), {
                    key: 8,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: "纳米易洁:",
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(q), {
                                disabled: c.value,
                                value: M.value,
                                "onUpdate:value": [
                                  t[13] || (t[13] = (o) => M.value = o),
                                  N
                                ]
                              }, {
                                default: i(() => [
                                  (d(!0), G(W, null, U(se.judge.filter(
                                    (o) => P.value ? o : !o.code
                                  ), (o, a) => (d(), h(s(B), {
                                    key: a,
                                    value: o.code
                                  }, {
                                    default: i(() => [
                                      R(E(o.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.handleGroup && e.handleGroup.gategories.length ? (d(), h(s(y), {
                    key: 9,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.handleGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(z), {
                                value: e.handleGroup.modelName,
                                "onUpdate:value": [
                                  t[14] || (t[14] = (o) => e.handleGroup.modelName = o),
                                  t[15] || (t[15] = () => N("拉手款式"))
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.handleGroup.gategories,
                                "label-field": "name",
                                "value-field": "name"
                              }, null, 8, ["value", "disabled", "options"]),
                              e.handleGroup.modelName ? (d(), h(s(z), {
                                key: 0,
                                value: e.handleGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.handleGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].model,
                                "onUpdate:value": [
                                  t[16] || (t[16] = (o) => e.handleGroup.gategories.filter(
                                    (a) => {
                                      var l;
                                      return a.name === ((l = e.handleGroup) == null ? void 0 : l.modelName);
                                    }
                                  )[0].model = o),
                                  N
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.handleGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.handleGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].options,
                                "label-field": "name",
                                "value-field": "optionId"
                              }, null, 8, ["value", "disabled", "options"])) : b("", !0)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.stoneGroup && e.stoneGroup.gategories.length ? (d(), h(s(y), {
                    key: 10,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.stoneGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(z), {
                                value: e.stoneGroup.modelName,
                                "onUpdate:value": [
                                  t[17] || (t[17] = (o) => e.stoneGroup.modelName = o),
                                  t[18] || (t[18] = () => N("石基"))
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.stoneGroup.gategories,
                                "label-field": "name",
                                "value-field": "name"
                              }, null, 8, ["value", "disabled", "options"]),
                              u(s(z), {
                                value: e.stoneGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.stoneGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].model,
                                "onUpdate:value": [
                                  t[19] || (t[19] = (o) => e.stoneGroup.gategories.filter(
                                    (a) => {
                                      var l;
                                      return a.name === ((l = e.stoneGroup) == null ? void 0 : l.modelName);
                                    }
                                  )[0].model = o),
                                  N
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.stoneGroup.gategories.filter(
                                  (o) => {
                                    var a;
                                    return o.name === ((a = e.stoneGroup) == null ? void 0 : a.modelName);
                                  }
                                )[0].options,
                                "label-field": "name",
                                "value-field": "optionId"
                              }, null, 8, ["value", "disabled", "options"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.productGroup ? (d(), h(s(y), {
                    key: 11,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: "石基先发:",
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(q), {
                                disabled: c.value,
                                value: k.value,
                                "onUpdate:value": [
                                  t[20] || (t[20] = (o) => k.value = o),
                                  N
                                ]
                              }, {
                                default: i(() => [
                                  (d(!0), G(W, null, U(se.judge.filter(
                                    (o) => oe.value ? o : !o.code
                                  ), (o, a) => (d(), h(s(B), {
                                    key: a,
                                    value: o.code
                                  }, {
                                    default: i(() => [
                                      R(E(o.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.shelfGroup && e.shelfGroup.gategories.length ? (d(), h(s(y), {
                    key: 12,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.shelfGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(z), {
                                value: e.shelfGroup.gategories[0].model,
                                "onUpdate:value": [
                                  t[21] || (t[21] = (o) => e.shelfGroup.gategories[0].model = o),
                                  N
                                ],
                                size: "small",
                                disabled: c.value,
                                options: e.shelfGroup.gategories[0].options,
                                "label-field": "name",
                                "value-field": "optionId"
                              }, null, 8, ["value", "disabled", "options"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.mujiaGroup && e.mujiaGroup.gategories.length ? (d(), h(s(y), {
                    key: 13,
                    class: "chang-gui"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: `${e.mujiaGroup.groupName}:`,
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              (d(!0), G(W, null, U(e.mujiaGroup.gategories, (o, a) => (d(), G("div", { key: a }, [
                                u(s(q), {
                                  disabled: c.value,
                                  value: o.model,
                                  "onUpdate:value": [(l) => o.model = l, N]
                                }, {
                                  default: i(() => [
                                    (d(!0), G(W, null, U(o.options, (l, r) => (d(), h(s(B), {
                                      key: r,
                                      value: l.optionId
                                    }, {
                                      default: i(() => [
                                        R(E(l.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "value", "onUpdate:value"])
                              ]))), 128))
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0),
                  e.mujiaGroup ? (d(), h(s(y), {
                    key: 14,
                    class: "kehuneirong"
                  }, {
                    default: i(() => [
                      u(s(w), {
                        span: 24,
                        class: "bottom-border"
                      }, {
                        default: i(() => [
                          u(s(C), {
                            label: "客户其他内容(限制100个字符):",
                            "label-placement": "left"
                          }, {
                            default: i(() => [
                              u(s(he), {
                                disabled: c.value,
                                type: "textarea",
                                value: T.value,
                                "onUpdate:value": t[22] || (t[22] = (o) => T.value = o),
                                maxlength: "100",
                                rows: 6,
                                placeholder: "请输入内容"
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : b("", !0)
                ])
              ]),
              _: 1
            }),
            D("div", Xe, [
              !c.value && n.openType !== "view" && e ? (d(), h(s(ce), {
                key: 0,
                type: "primary",
                size: "small",
                onClick: Oe
              }, {
                default: i(() => t[30] || (t[30] = [
                  R(" 保存 ", -1)
                ])),
                _: 1,
                __: [30]
              })) : b("", !0),
              u(s(ce), {
                type: "primary",
                size: "small",
                onClick: xe
              }, {
                default: i(() => t[31] || (t[31] = [
                  R(" 关闭 ", -1)
                ])),
                _: 1,
                __: [31]
              })
            ])
          ])), [
            [m, A.value]
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
export {
  Io as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/ShowerRoomModel/ShowerRoomModel.vue.js
// module id = 1196
// module chunks = 41